import React from "react";
import Button from "../../../../_components/Button";
import TableData from "../../../../_components/TableData";
import Text from "../../../../_components/Text";
import Modal from "../../../../_components/Modal";
import IconButton from "../../../../_components/IconButton";

import { toast } from "react-toastify";

import moment from "moment/moment";

import {
  handlerChoicesShortOption,
  onGetDefaultStartEnDate,
  checkInterval,
  getPreviousMonthInfo,
} from "./helpers";

import {
  getNFeBatch,
  createNFeBatch,
  syncBacth,
  downloadBatch,
} from "../../../../api/nfe";
import DatePicker from "react-datepicker";
import { donwloadBase64, formatDate } from "../../../../utils";

const IconLoading = ({
  loadingIcon = "fas fa-spinner fa-pulse",
  defaultIcon = "sync",
  onClickAction,
}) => {
  const [waiting, setWaiting] = React.useState(false);

  const onClick = () => {
    setWaiting(true);

    return onClickAction()
      .then((response) => {
        console.log("Success:", response);
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setTimeout(() => {
          setWaiting(false);
        }, 1000);
      });
  };

  if (waiting) {
    return (
      <span className="mx-2">
        <i className={loadingIcon} />
      </span>
    );
  } else {
    return (
      <span className="mx-2">
        <IconButton onClick={onClick} icon={defaultIcon} />
      </span>
    );
  }
};

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [show, setShow] = React.useState(false);
  const ref = React.useRef(null);
  const [lastMonth, setLastMonth] = React.useState(getPreviousMonthInfo());
  const [feedback, setFeedbak] = React.useState({
    type: "",
    text: "",
  });
  const [batch, setBatchData] = React.useState({
    start_date: null,
    end_date: null,
    minDate: null,
  });
  const [result, setResult] = React.useState({
    showModal: false,
    protocolNumber: "",
    totalDocuments: 0,
    nextUpdate: "",
  });

  const onOpenModal = () => {
    if (loading) {
      return;
    }
    const [currentStartDate, currentEndDate] = onGetDefaultStartEnDate();
    const minDate = checkInterval(currentEndDate);
    setBatchData({
      start_date: moment(currentStartDate),
      end_date: moment(currentEndDate),
      minDate,
    });
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setFeedbak({ text: "", type: "" });
  };
  const choiceOptions = (option) => {
    const [start_date, end_date] = handlerChoicesShortOption(option);
    const minDate = checkInterval(end_date);
    setBatchData({
      start_date: moment(start_date),
      end_date: moment(end_date),
      minDate: moment(minDate),
    });
  };
  const createBacth = () => {
    setFeedbak({
      text: "",
      type: "",
    });
    setLoading(true);
    createNFeBatch(batch)
      .then((resp) => {
        handleClose();
        let newUpdate = new Date(resp.on_finish).toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false, // Usa o formato 24 horas
        });
        setResult({
          showModal: true,
          protocolNumber: resp.protocol_number,
          totalDocuments: resp.total_documents,
          nextUpdate: newUpdate,
        });
      })
      .catch((error) => {
        if (error.batch_error) {
          if (error.batch_error === "batch without results") {
            setFeedbak({
              type: "danger",
              text: "Nenhuma NF-e encontrada nesse intervalo de datas.",
            });
          }
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2500);
      });
  };
  const onSyncBatchStatus = (protocolNumber) => {
    return new Promise((resolve, reject) => {
      syncBacth(protocolNumber)
        .then((response) => {
          if (response.status) {
            toast.success(
              <Text color="white">
                Lote disponível. Realizando o download...
              </Text>,
              {
                position: "top-center",
                toastId: "batch-available",
              }
            );
            downloadBatch(protocolNumber).then((response) => {
              donwloadBase64(protocolNumber, "zip", "", response.base64);
              resolve();
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            });
          } else {
            toast.info(<Text color="white">Lote ainda não disponível. {response.next_update}</Text>, {
              position: "top-center",
              toastId: "batch-unavailable",
            });
            resolve(response);
          }
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  };
  const handleDownloadBatch = (protocolNumber) => {
    return new Promise((resolve, reject) => {
      downloadBatch(protocolNumber).then((response) => {
        donwloadBase64(protocolNumber, "zip", "", response.base64);
        resolve();
      });
    });
  };
  const handlerChangeEndDate = (value) => {
    const minDate = checkInterval(value);
    setBatchData({
      ...batch,
      minDate,
      end_date: value,
    });
  };
  const closeModalResult = () => {
    setResult({
      showModal: false,
      protocolNumber: "",
      totalDocuments: 0,
      nextUpdate: "",
    });
    window.location.reload();
  };
  React.useEffect(() => {
    getNFeBatch()
      .then((resp) => {
        setData(
          resp.map((item) => {
            return {
              ...item,
              start_date: formatDate(moment(item.start_date).add(1, 'seconds')),
              end_date: formatDate(moment(item.end_date).add(1, 'seconds')),


              status:
                item.status == 1 ? (
                  <span className="badge badge-warning">processando...</span>
                ) : (
                  <span className="badge badge-success">lote disponível</span>
                ),
              created_date: (
                <div>
                  {item.status == 1 ? (
                    <React.Fragment>
                      <IconLoading
                        loadingIcon="fas fa-circle-notch fa-spin"
                        defaultIcon="sync"
                        onClickAction={() =>
                          onSyncBatchStatus(item.protocol_number)
                        }
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <IconLoading
                        loadingIcon="fas fa-circle-notch fa-spin"
                        defaultIcon="download"
                        onClickAction={() =>
                          handleDownloadBatch(item.protocol_number)
                        }
                      />
                    </React.Fragment>
                  )}
                  {formatDate(moment(item.created_date).add(1, 'seconds'), true)}
                </div>
              ),
            };
          })
        );
      })
      .catch((error) => { });
  }, [ref.current]);
  return (
    <div className="container-fluid" ref={ref}>
      <div className="row">
        <div className="col-12 py-4">
          <Text fontSize="md">Exportações em lote</Text>
          <Button onClick={onOpenModal}>Exportar novo lote de NF-e</Button>
        </div>
        <div className="col-12">
          <TableData
            tBodyKeys={[
              "created_date",
              "status",
              "start_date",
              "end_date",
              "total_documents",
              "protocol_number",
            ]}
            tHead={[
              "Data da solicitação",
              "Status",
              "Data inicial",
              "Data final",
              "Qtd. de documentos",
              "Protocolo",
            ]}
            data={data}
          />
        </div>
      </div>
      <Modal title="Exportar lote de NF-e" show={show} onHide={handleClose}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <div className="form-label">
                <Text>Data inicial</Text>
              </div>
              <DatePicker
                selected={batch.start_date}
                minDate={batch.minDate}
                dateFormat="DD/MM/yyyy"
                onChange={(e) => {
                  setBatchData({
                    ...batch,
                    start_date: e,
                  });
                }}
                disabled={loading}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <div className="form-label">
                <Text>Data final</Text>
              </div>
              <DatePicker
                selected={batch.end_date}
                maxDate={moment(new Date())}
                onChange={handlerChangeEndDate}
                dateFormat="DD/MM/yyyy"
                disabled={loading}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <div className="form-label">
                <Text>Selecione um Período Rápido:</Text>
              </div>
              <div className="my-2">
                <Button
                  disabled={loading}
                  onClick={() => choiceOptions("default")}
                  className="w-100"
                >
                  Este mês (do dia 1 ao dia {new Date().getDate()} )
                </Button>
              </div>
              <Button
                onClick={() => choiceOptions("last_month")}
                disabled={loading}
                className="w-100"
              >
                Mês anterior (1 a {lastMonth.lastDay} de {lastMonth.monthName})
              </Button>
            </div>
          </div>
        </div>
        <Text align="center" color={feedback.type}>
          {feedback.text}
        </Text>
        <div className="d-flex justify-content-center">
          <Button disabled={loading} onClick={createBacth}>
            Exportar lote
          </Button>
        </div>
      </Modal>
      <Modal
        title={`Protocolo de exportação gerado ${result.protocolNumber}`}
        show={result.showModal}
        onHide={closeModalResult}
      >
        <Text align="center" fontSize="md">
          Total de NF-e: {result.totalDocuments}
        </Text>
        <Text align="center" fontSize="md">
          Previsão de conconclusão: {result.nextUpdate}
        </Text>
        <div className="d-flex justify-content-center my-3">
          <Button onClick={closeModalResult}>OK</Button>
        </div>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/BatchNFe/index.jsx